// TO DO remove any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isPlainObject(item: unknown): item is Record<keyof any, unknown> {
    return item !== null && typeof item === 'object' && item?.constructor === Object;
}

export interface DeepmergeOptions {
    clone?: boolean;
}

export function deepMerge<T>(target: T, source: unknown, options: DeepmergeOptions = { clone: true }): T {
    const output = options.clone ? { ...target } : target;

    if (isPlainObject(target) && isPlainObject(source)) {
        Object.keys(source).forEach((key) => {
            // Avoid prototype pollution
            if (key === '__proto__') {
                return;
            }

            if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
                // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
                // TO DO remove any
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (output as Record<keyof any, unknown>)[key] = deepMerge(target[key], source[key], options);
            } else {
                // TO DO remove any
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (output as Record<keyof any, unknown>)[key] = source[key];
            }
        });
    }

    return output;
}
